import { render, staticRenderFns } from "./FilesViewer.vue?vue&type=template&id=177aec5e&scoped=true&"
import script from "./FilesViewer.vue?vue&type=script&lang=js&"
export * from "./FilesViewer.vue?vue&type=script&lang=js&"
import style0 from "./FilesViewer.vue?vue&type=style&index=0&id=177aec5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177aec5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VImg,VLayout})
